import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assertSuccessfulWorkerResponse } from "./helpers";
import { showSuccessToast } from "../../utils/showToastAlert";

export function usePostParticipantWithdraw({
  callApiWithWorker,
  t,
  onErrorAlert,
}) {
  const qc = useQueryClient();

  return useMutation({
    mutationKey: ["participants", "withdraw"],
    mutationFn: async ({ participantId }) => {
      if (!participantId) throw new Error("Missing participantId");

      const res = await callApiWithWorker(
        `/registry/participants/${encodeURIComponent(participantId)}/withdraw`,
        {
          method: "POST",
          connector: "springConnector",
        },
      );

      return assertSuccessfulWorkerResponse(res, "Withdraw participant failed");
    },
    onSuccess: async (_data, vars) => {
      await qc.invalidateQueries({ queryKey: ["participants"] });
      await qc.invalidateQueries({
        queryKey: ["participants", "byId", vars?.participantId],
      });

      showSuccessToast(
        t?.(
          vars?.successMessageKey ?? "participant.approval.updated.deactivate",
          vars?.successMessageFallback ??
            "Participant deactivated successfully",
        ),
        {
          title: t?.("participant.approval.updatedTitle", "Approval updated"),
        },
      );
    },
    onError: async (err) => {
      if (onErrorAlert) return onErrorAlert(err);
      console.error(t ? t("error") : "Error", err);
    },
  });
}
